/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE11 and Safari 10 require the following for NgClass support on SVG elements */
import 'classlist.js'; // Run `npm install --save classlist.js`

/** IE11 and Safari 10 require the following to reflect properties */
import 'core-js/features/reflect';

/** Evergreen browsers require these. **/
import 'core-js/stable';
import 'regenerator-runtime/runtime';

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
